import { defineMessages } from 'react-intl';

export const jsmPortalPlaygroundMessages = defineMessages({
	sectionLabel: {
		id: 'JsmPortalPlayground.sectionLabel',
		defaultMessage: 'Jira Service Management preview',
	},
	serviceTeamTabListLabel: {
		id: 'JsmPortalPlayground.serviceTeamTabListLabel',
		defaultMessage: 'Service team',
	},
	teamItSupport: {
		id: 'JsmPortalPlayground.teamItSupport',
		defaultMessage: 'IT support',
	},
	teamItOperations: {
		id: 'JsmPortalPlayground.teamItOperations',
		defaultMessage: 'IT operations',
	},
	teamEngineering: {
		id: 'JsmPortalPlayground.teamEngineering',
		defaultMessage: 'Engineering',
	},
	teamHr: {
		id: 'JsmPortalPlayground.teamHr',
		defaultMessage: 'HR',
	},
	customCursorLabel: {
		id: 'JsmPortalPlayground.customCursorLabel',
		defaultMessage: 'You',
	},
	navigationPreviewLabel: {
		id: 'JsmPortalPlayground.navigationPreviewLabel',
		defaultMessage: 'Jira Service Management navigation preview for {teamName}',
	},
	productName: {
		id: 'JsmPortalPlayground.productName',
		defaultMessage: 'Jira Service Management',
	},
	back: {
		id: 'JsmPortalPlayground.back',
		defaultMessage: 'Back',
	},
	search: {
		id: 'JsmPortalPlayground.search',
		defaultMessage: 'Search',
	},
	create: {
		id: 'JsmPortalPlayground.create',
		defaultMessage: 'Create',
	},
	askRovo: {
		id: 'JsmPortalPlayground.askRovo',
		defaultMessage: 'Ask Rovo',
	},
	customizeHelpCenter: {
		id: 'JsmPortalPlayground.customizeHelpCenter',
		defaultMessage: 'Customize the help center',
	},
});
